export default __webpack_public_path__ + "CircularCustCapNum-Light.238771dfd59d92af21af76cdb8f19401.woff";